import { ReferralInfo } from 'data/Referral/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const fetchInfo = () =>
  fetchApi<ReferralInfo>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/referral/info?platform=exchange')
  })
